import React from 'react';
import PropTypes from 'prop-types';

import AddPaymentModal from './Add';
import EditPaymentModal from './Edit';
import CompletePaymentModal from './Complete';
import ReportPaymentModal from './Report';
import DetailsPaymentModal from './Details';
import RejectModal from './Reject';

const ModalsManager = ({ open, item, details, error, isLoading, isLoadingSubmit, methods, excludedMethods, onHide, onSubmit }) => (
  <>
    <AddPaymentModal
      open={open === 'add'}
      error={error}
      isLoading={isLoading}
      isLoadingSubmit={isLoadingSubmit}
      methods={methods}
      excludedMethods={excludedMethods}
      onHide={onHide}
      onSubmit={onSubmit}
    />
    <EditPaymentModal
      open={open === 'edit'}
      item={item}
      methods={methods}
      error={error}
      isLoading={isLoading}
      isLoadingSubmit={isLoadingSubmit}
      onHide={onHide}
      onSubmit={onSubmit}
    />
    <CompletePaymentModal open={open === 'complete'} item={item} error={error} isLoading={isLoading} onHide={onHide} onSubmit={onSubmit} />
    <ReportPaymentModal open={open === 'report'} error={error} isLoading={isLoading} onHide={onHide} onSubmit={onSubmit} />
    <DetailsPaymentModal open={open === 'details'} item={item} details={details} isLoading={isLoading} onHide={onHide} />
    <RejectModal open={open === 'reject'} item={item} onHide={onHide} onSubmit={onSubmit} />
  </>
);

ModalsManager.propTypes = {
  open: PropTypes.string,
  item: PropTypes.object,
  details: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  methods: PropTypes.array,
  excludedMethods: PropTypes.array,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ModalsManager;
